"use client";

import * as React from "react";

interface AnimatedNumberProps {
  value: number;
  duration?: number;
}

export function AnimatedNumber({ value, duration = 600 }: AnimatedNumberProps) {
  const [displayValue, setDisplayValue] = React.useState<number>(value);
  const startValueRef = React.useRef<number>(value);

  React.useEffect(() => {
    const start = startValueRef.current;
    const end = value;
    const startTime = performance.now();

    function animate(currentTime: number) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const current = Math.floor(start + (end - start) * progress);
      setDisplayValue(current);

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        startValueRef.current = end;
      }
    }

    requestAnimationFrame(animate);
  }, [value, duration]);

  return (
    <>{displayValue != null ? displayValue.toLocaleString("cs-CZ") : "-"}</>
  );
}
